export const RouterPaths = {
  cashapp: '/cashapp',
  phone: '/phone',
  registered: '/home/registered'
};
